import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getFloorplanUploadSignedUrl } from '../services/getFloorplanUploadSignedUrl.service';
import { postCreateFloorplan } from '../services/postCreateFloorplan.service';
import getFileExtension from 'utils/getFileExtension';
import uuidv4 from 'uuid/v4';

export const uploadFloorplan = createAsyncThunk(
  'floorplans/uploadFloorplan',
  async ({ projectId, name, file, onProgress }, { rejectWithValue }) => {
    try {
      const id = uuidv4();
      const fileExtension = getFileExtension(file.name);
      const s3FileName = `${id}.${fileExtension}`;

      const signedUrl = await getFloorplanUploadSignedUrl({
        projectId,
        fileName: s3FileName,
        contentType: file.type,
      });

      await axios.put(signedUrl, file, {
        headers: { 'Content-Type': file.type },
        onUploadProgress: (progressEvent) => {
          if (onProgress) {
            const percentage = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            );
            onProgress(percentage);
          }
        },
      });

      const floorplan = await postCreateFloorplan(projectId, {
        name,
        s3FileName,
        contentType: file.type,
      });

      return floorplan;
    } catch (err) {
      return rejectWithValue({ message: err.message });
    }
  }
);
